import { render } from "./UsageRecords.vue?vue&type=template&id=1e4a67de&scoped=true"
import script from "./UsageRecords.vue?vue&type=script&lang=js"
export * from "./UsageRecords.vue?vue&type=script&lang=js"

import "./UsageRecords.vue?vue&type=style&index=0&id=1e4a67de&lang=less&scoped=true"

import exportComponent from "/home/pedro/git/cloudstack/scclouds/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e4a67de"]])

export default __exports__